module.exports = __webpack_public_path__ + "img/portfolio-7.b0dccc79.jpg";